
import React, { Dispatch, FC, SetStateAction } from 'react';
import { TouchableOpacity, View, useWindowDimensions } from 'react-native';
import { Theme, ThemeConsumer } from '@rneui/themed';
//Module
import { useAppNavigation } from '../../types/@react-navigation/navigation';
import { ZenHeader, ZenIcon, ZenStatusBar, ZenText } from 'zen-core-elements';

type backIcon =
    | {
        backIcon?: true,
        backIconOnpress: () => void
    } |
    {
        backIcon?: false,
        backIconOnpress?: () => void
    }
type commonHeaderProps = {
    headerName: string
    leftIconHidden?: boolean
    leftIconOnpress?: Dispatch<SetStateAction<any>>
    rightComponent?: React.JSX.Element | null
    leftComponent?: React.JSX.Element
    textBadge?: React.JSX.Element
}

type CommonHeaderProps = commonHeaderProps & backIcon
const CommonHeader: FC<CommonHeaderProps> = React.memo(({ headerName, leftIconOnpress, rightComponent, leftIconHidden, backIcon, backIconOnpress, leftComponent, textBadge }) => {
    const { width } = useWindowDimensions()
    const navigation = useAppNavigation()
    return (
        <ThemeConsumer>
            {({ theme }: { theme: Theme }) => (
                <View>
                    <ZenStatusBar barStyle={"dark-content"} bgColor={theme.light} />

                    <ZenHeader
                        color={theme?.light}
                        rightComponent={rightComponent}
                        rightComponentStyle={rightComponent && { flex: 1, alignItems: "flex-end", paddingRight: 15 }}
                        centerComponentStyle={{ flex: 0 }}
                        leftComponentStyle={{ flex: 1, alignItems: "flex-start", paddingLeft: 15 }}
                        leftComponent={
                            leftComponent ||
                            <View style={{ flexDirection: "row", alignItems: "center", gap: 15 }}>
                                {
                                    backIcon ?
                                        <TouchableOpacity onPress={backIconOnpress}>
                                            <ZenIcon name={"arrow-left"} type={"material-community"} size={width > 600 ? 28 : 22} color={theme?.dark} />
                                        </TouchableOpacity> :
                                        !leftIconHidden && (width <= 900) ?
                                            <TouchableOpacity onPress={
                                                leftIconOnpress ?
                                                    leftIconOnpress : () =>
                                                        navigation?.openDrawer()}>
                                                <ZenIcon name={'dots-grid'} type={"material-community"} size={width > 600 ? 28 : 22} color={theme?.dark} />
                                            </TouchableOpacity>
                                            : null}
                                <ZenText content={headerName} size={theme?.headerFontSize} bold color={theme?.dark} />
                                {
                                    textBadge && textBadge
                                }
                            </View>
                        }
                    />
                </View>
            )}
        </ThemeConsumer>
    );
})


export default CommonHeader;
